<template>
  <hic-dialog title="患者信息" :visible="visible" @open="getPatient" @close="$emit('update:visible', false)">
    <el-form ref="formRef" v-loading="meta.loading" :model="entity" label-width="100px">
      <el-row :gutter="20">

        <el-col :span="12">
          <el-form-item label="姓名">
            <el-input v-model="entity.name" :disabled="true" size="small"></el-input>
          </el-form-item></el-col>
        <el-col :span="12">
          <el-form-item label="号码">
            <el-input v-model="entity.idNo" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别">
            <hic-dict-selector v-model="entity.gender" dict-type="Gender"></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="年龄" prop="">
            <el-input maxlength="30" v-model="entity.patientAge" type="number" clearable @blur="ageChange" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="民族">
            <hic-dict-selector v-model="entity.ethnicity" dict-type="Ethnicity"></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入院时间" prop="">
            <el-date-picker size="small" v-model="entity.startDate" type="datetime" placeholder="请选择"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="体温" prop="temperature">
            <el-input maxlength="6" type="number" v-model="entity.temperature" clearable size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="症状" prop="symptoms">
            <el-input v-model="entity.symptoms" clearable size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出生年月日" prop="birthDate">
            <el-date-picker v-model="entity.birthDate" style="width: 100%;" type="date" size="small"
              value-format="yyyy-MM-dd" placeholder="选择出生年月日" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分组" prop="groupType">
            <hic-dict-selector dict-type="PatientGroup" is-enum v-model="entity.groupType"
              placeholder="请选择"></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="办案人单位" prop="contactCompany">
            <el-input maxlength="30" size="small" v-model="entity.contactCompany" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="办案人" prop="contactName">
            <el-input maxlength="30" size="small" v-model="entity.contactName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input maxlength="30" size="small" v-model="entity.contactPhone" clearable ></el-input>
            <!-- <el-button icon="el-icon-plus" size="mini" type="primary" circle plain class="left-pad"></el-button> -->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="传染病" prop="epidemic">
            <hic-text-selector dict-type="Epidemic" v-model="entity.epidemic" placeholder="请选择" :multiple="true"
              @change="changeEpidemic"></hic-text-selector>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="新冠" prop="covid19">
            <hic-dict-selector dict-type="Covid19" v-model="entity.covid19" placeholder="请选择" auto></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="接收既往病历" prop="ifMedicalRecordReceived">
            <el-radio-group v-model="entity.ifMedicalRecordReceived" @input="changedMedicalRecordReceived">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="接收人" prop="medicalRecordReceivedUserCode">
            <hic-staff-selector :dept="entity.deptCode" v-model="entity.medicalRecordReceivedUserCode" :name.sync="entity.medicalRecordReceivedUserName" :disabled="!entity.ifMedicalRecordReceived" class="f-w"></hic-staff-selector>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="接收日期" prop="medicalRecordReceivedDate">
            <el-date-picker v-model="entity.medicalRecordReceivedDate" style="width: 100%;" type="date" size="small" value-format="yyyy-MM-dd" placeholder="接收日期" :disabled="!entity.ifMedicalRecordReceived" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button type="info" @click="$emit('update:visible', false)">取 消</el-button>
      <el-button :disabled="meta.loading" type="primary" @click="save">确 定</el-button>
    </template>
  </hic-dialog>
</template>
<script>
import api from "./api";
export default {
  props: {
    id: String,
    info: Object,
    visible: Boolean,
  },
  data() {
    return {
      meta: {
        loading: false
      },
      patient: {},
      hospitalization: {},
      entity: {}
    };
  },
  methods: {
    getPatient() {
      try {
        this.$refs.formRef.resetField()
      } catch (e) {

      }
      api.Patient.get(this.id).then((res) => {
        this.patient = res;
        this.$set(this.entity, "name", res.name);
        this.$set(this.entity, "idNo", res.idNo);
        this.$set(this.entity, "gender", res.gender);
        this.$set(this.entity, "patientAge", parseInt(res.patientAge));
        this.$set(this.entity, "ethnicity", res.ethnicity);
        return api.Hospitalization.get(this.info.id);
      }).then((res) => {
        this.hospitalization = res
        this.$set(this.entity, "startDate", res.startDate);
        this.$set(this.entity, "contactCompany", res.contactCompany);
        this.$set(this.entity, "contactName", res.contactName);
        this.$set(this.entity, "contactPhone", res.contactPhone);
        this.$set(this.entity, "epidemic", res.epidemic ? res.epidemic.split(",") : []);
        this.$set(this.entity, "covid19", res.covid19);
        
        this.$set(this.entity, "groupType", res.groupType);
        this.$set(this.entity, "symptoms", res.symptoms);
        this.$set(this.entity, "temperature", res.temperature);
        this.$set(this.entity, "birthDate", res.birthDate);

        this.$set(this.entity, "ifMedicalRecordReceived", res.ifMedicalRecordReceived);
        this.$set(this.entity, "medicalRecordReceivedUserCode", res.medicalRecordReceivedUserCode);
        this.$set(this.entity, "medicalRecordReceivedUserName", res.medicalRecordReceivedUserName);
        this.$set(this.entity, "medicalRecordReceivedDate", res.medicalRecordReceivedDate);
      })
    },
    dateBrithday(val) {
        if (val) {
          let _arr = val.split('-')
          return _arr[0] + '-' + _arr[1]
        }
      },
    ageChange() {
      let nowYear = this.$utils.Dt.today().substring(0, 4);
      let birthYear = parseInt(nowYear) - parseInt(this.entity.patientAge);
      this.$set(this.entity, "patientBirthday", birthYear + "-01-01");
    },
    save() {
      this.ageChange() //初始化生日

      this.$set(this.patient, "name", this.entity.name);
      this.$set(this.patient, "idNo", this.entity.idNo);
      this.$set(this.patient, "gender", this.entity.gender);
      this.$set(this.patient, "patientAge", this.entity.patientAge);
      this.$set(this.patient, "ethnicity", this.entity.ethnicity);
      this.$set(this.patient, "birthday", this.entity.patientBirthday);

      this.$set(this.patient, "groupType", this.entity.groupType);
      this.$set(this.patient, "symptoms", this.entity.symptoms);
      this.$set(this.patient, "temperature", this.entity.temperature);
      this.$set(this.patient, "birthDate", this.entity.birthDate);

      this.$set(this.patient, "ifMedicalRecordReceived", this.entity.ifMedicalRecordReceived);
      this.$set(this.patient, "medicalRecordReceivedUserCode", this.entity.medicalRecordReceivedUserCode);
      this.$set(this.patient, "medicalRecordReceivedUserName", this.entity.medicalRecordReceivedUserName);
      this.$set(this.patient, "medicalRecordReceivedDate", this.entity.medicalRecordReceivedDate);
      this.meta.loading = true;
      api.Patient.save(this.patient).then((res) => {

        this.$set(this.hospitalization, "patientName", res.name);
        this.$set(this.hospitalization, "patientGender", res.gender);
        this.$set(this.hospitalization, "patientBirthday", res.birthday);
        this.$set(this.hospitalization, "patientAge", res.patientAge);


        this.$set(this.hospitalization, "startDate", this.entity.startDate);
        this.$set(this.hospitalization, "contactCompany", this.entity.contactCompany);
        this.$set(this.hospitalization, "contactName", this.entity.contactName);
        this.$set(this.hospitalization, "contactPhone", this.entity.contactPhone);
        this.$set(this.hospitalization, "epidemic", this.entity.epidemic ? this.entity.epidemic.join(",") : '');
        this.$set(this.hospitalization, "covid19", this.entity.covid19);

        this.$set(this.hospitalization, "groupType", this.entity.groupType);
        this.$set(this.hospitalization, "symptoms", this.entity.symptoms);
        this.$set(this.hospitalization, "temperature", this.entity.temperature);
        this.$set(this.hospitalization, "birthDate", this.entity.birthDate);

        this.$set(this.hospitalization, "ifMedicalRecordReceived", this.entity.ifMedicalRecordReceived);
        this.$set(this.hospitalization, "medicalRecordReceivedUserCode", this.entity.medicalRecordReceivedUserCode);
        this.$set(this.hospitalization, "medicalRecordReceivedUserName", this.entity.medicalRecordReceivedUserName);
        this.$set(this.hospitalization, "medicalRecordReceivedDate", this.entity.medicalRecordReceivedDate);

        this.$emit("saved", res);
        return api.Hospitalization.save(this.hospitalization)
      }).then((res) => {
        this.meta.loading = false;
        this.$emit("update:visible", false);
      })
    },
    changeEpidemic(val) {
      if (val.indexOf('无') > -1) this.entity.epidemic = ['无']
      else if (val.indexOf('未确定') > -1) this.entity.epidemic = ['未确定']
    },
    changedMedicalRecordReceived(val) {
      if (!val) {
        this.entity.medicalRecordReceivedUserCode = null;
        this.entity.medicalRecordReceivedUserName = null;
        this.entity.medicalRecordReceivedDate = null;
      }
    },
  },
};
</script>
